import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useWarehouseClient } from "../../apis/warehouseClient/WarehouseClientProvider";
import { WarehouseClientResponse } from "../../services/warehouseClientService";
import warehouseClient from "../../types/warehouseClient";
import { useTranslation } from "react-i18next";

interface WarehouseSectionProps {
    selectedWarehouses: number[];
    setSelectedWarehouses: (ids: number[]) => void;
    isEditing: boolean;
    userWarehouses?: warehouseClient[];
}

const WarehouseSection: React.FC<WarehouseSectionProps> = ({
    selectedWarehouses,
    setSelectedWarehouses,
    isEditing,
    userWarehouses
}) => {
    const { t } = useTranslation();
    const { fetchWarehouseClient } = useWarehouseClient();
    const [groupedWarehouses, setGroupedWarehouses] = useState<{
        [wrName: string]: WarehouseClientResponse[];
    }>({});

    useEffect(() => {
        let isMounted = true;
        
        const fetchData = async () => {
            const values: WarehouseClientResponse[] = await fetchWarehouseClient();
    
            if (!isMounted) return;
            
            const grouped: { [wrName: string]: WarehouseClientResponse[] } = {};
            values.forEach((entry) => {
                if (!grouped[entry.wrName]) {
                    grouped[entry.wrName] = [];
                }
                grouped[entry.wrName].push(entry);
            });
    
            setGroupedWarehouses(grouped);
    
            // 🟢 Marcar checkboxes automaticamente com base nos pares wrId + clientId
            if (userWarehouses?.length) {
                const matchedIds = values
                    .filter((entry) =>
                        userWarehouses.some(
                            (uw) => uw.client?.id === entry.clientId && uw.wr?.id === entry.wrId
                        )
                    )
                    .map((entry) => entry.id);
    
                setSelectedWarehouses(matchedIds);
            }
        };
    
        fetchData();
        
        return () => { isMounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userWarehouses]);
    

    const toggleWarehouse = (id: number) => {
        if (!isEditing) return;

        const alreadySelected = selectedWarehouses.includes(id);
        const updated = alreadySelected
            ? selectedWarehouses.filter((wid) => wid !== id)
            : [...selectedWarehouses, id];

        setSelectedWarehouses(updated);
    };

    return (
        <div>
            <Form.Label>{t('destination.labels.warehouses')}</Form.Label>
            {Object.entries(groupedWarehouses).map(([wrName, clients]) => (
                <div key={wrName} className="mb-3">
                    <strong>{wrName}:</strong>{" "}
                    {clients.map((client) => (
                        <Form.Check
                            key={client.id}
                            inline
                            type="checkbox"
                            id={`warehouse-${client.id}`}
                            label={client.clientName}
                            checked={selectedWarehouses.includes(client.id)}
                            onChange={() => toggleWarehouse(client.id)}
                            disabled={!isEditing}
                            style={{
                                fontWeight: selectedWarehouses.includes(client.id) ? 'bold' : 'normal',
                                color: selectedWarehouses.includes(client.id) ? '#000000' : '#6c757d',
                                opacity: 1
                            }}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default WarehouseSection;
